(() => {
  const STORAGE_KEY = "coolstar_saved_designs_v1";
  const form = document.getElementById("chip-customizer-form");
  const preview = document.getElementById("chip-preview");
  if (!form || !preview) return;

  const state = { editSide: "front", previewSide: "front", images: { front: {}, back: {} }, editingId: "" };
  window.CoolstarChipCustomizer = { getImages: () => state.images, getEditSide: () => state.editSide };
  const getDesigns = () => {
    try { const rows = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); return Array.isArray(rows) ? rows : []; }
    catch { return []; }
  };
  const safeColor = value => /^#[\da-f]{6}$/i.test(value || "") ? value : "#8d263b";
  const xml = value => String(value ?? "").replace(/[&<>"']/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" }[char]));
  const field = name => form.elements.namedItem(name);
  const value = name => field(name)?.value || "";
  const checked = name => Boolean(field(name)?.checked);
  const sideValues = side => ({
    value: value(`${side}Value`) || "500", mark: value(`${side}Mark`), top: value(`${side}Top`), bottom: value(`${side}Bottom`),
    left: value(`${side}Left`) || "spade", right: value(`${side}Right`) || "diamond"
  });
  const icon = kind => ({ spade: "♠", diamond: "♦", club: "♣", heart: "♥", star: "✦" }[kind] || "✦");
  const displayImage = (side, key, x, y, size) => {
    const src = state.images[side]?.[key];
    return src ? `<image href="${src}" x="${x}" y="${y}" width="${size}" height="${size}" preserveAspectRatio="xMidYMid meet"/>` : "";
  };
  const makePreview = () => {
    const side = state.previewSide;
    const face = sideValues(side);
    const round = value("shape") !== "rectangle";
    const outer = safeColor(value("outerColor"));
    const rim = safeColor(value("rimColor"));
    const inner = safeColor(value("innerColor"));
    const textColor = safeColor(value("textColor"));
    const includeRim = checked("chipInsert");
    const marks = includeRim && value("edgePattern") !== "plain" ? Array.from({ length: round ? 12 : 16 }, (_, i) => {
      const rotation = i * 30;
      const fill = value("edgePattern") === "diamond" ? rim : "#f8f2ea";
      const dash = value("edgePattern") === "dash" ? "height=22 y=48" : "height=32 y=42";
      if (round) return `<rect x="240" ${dash} width="20" rx="7" fill="${fill}" transform="rotate(${rotation} 250 240)"/>`;
      const isShort = value("edgePattern") === "dash";
      if (i < 6) return `<rect x="${72 + i * 71}" y="81" width="${isShort ? 20 : 32}" height="17" rx="7" fill="${fill}"/>`;
      if (i < 12) return `<rect x="${72 + (i - 6) * 71}" y="382" width="${isShort ? 20 : 32}" height="17" rx="7" fill="${fill}"/>`;
      const sideY = 137 + (i - 12) * 82;
      return `<rect x="${i < 14 ? 49 : 431}" y="${sideY}" width="17" height="${isShort ? 22 : 32}" rx="7" fill="${fill}"/>`;
    }).join("") : "";
    const base = round
      ? `<circle cx="250" cy="240" r="204" fill="#171619"/><circle cx="250" cy="240" r="197" fill="${outer}" stroke="${rim}" stroke-width="5"/><circle cx="250" cy="240" r="158" fill="${includeRim ? rim : outer}"/><circle cx="250" cy="240" r="143" fill="${inner}" stroke="#201b1f" stroke-opacity=".4" stroke-width="2"/>`
      : `<rect x="35" y="65" width="430" height="350" rx="56" fill="#171619"/><rect x="42" y="72" width="416" height="336" rx="50" fill="${outer}" stroke="${rim}" stroke-width="5"/><rect x="69" y="99" width="362" height="282" rx="39" fill="${includeRim ? rim : outer}"/><rect x="83" y="113" width="334" height="254" rx="31" fill="${inner}" stroke="#201b1f" stroke-opacity=".4" stroke-width="2"/>`;
    const clip = round ? `<clipPath id="faceClip"><circle cx="250" cy="240" r="141"/></clipPath>` : `<clipPath id="faceClip"><rect x="84" y="114" width="332" height="252" rx="30"/></clipPath>`;
    const imgMode = checked("artUploadMode") && state.images[side]?.artwork;
    const artwork = imgMode
      ? `<image href="${state.images[side].artwork}" x="${round ? 109 : 88}" y="${round ? 99 : 117}" width="${round ? 282 : 324}" height="${round ? 282 : 246}" preserveAspectRatio="xMidYMid slice" clip-path="url(#faceClip)" opacity=".88"/>`
      : value("artStyle") === "geometric" ? `<g clip-path="url(#faceClip)" fill="none" stroke="${outer}" stroke-opacity=".2" stroke-width="8"><path d="M85 140 250 310 420 140M85 335 250 165 420 335"/><circle cx="250" cy="240" r="88"/></g>`
      : value("artStyle") === "minimal" ? `<g clip-path="url(#faceClip)" fill="none" stroke="${outer}" stroke-opacity=".27" stroke-width="3"><circle cx="250" cy="240" r="94"/><circle cx="250" cy="240" r="112"/></g>`
      : value("artStyle") === "casino" ? `<g clip-path="url(#faceClip)" fill="none" stroke="${outer}" stroke-opacity=".23" stroke-width="3"><circle cx="250" cy="240" r="119"/><path d="M110 240h280M250 102v276"/></g>`
      : `<g clip-path="url(#faceClip)" fill="none" stroke="${outer}" stroke-opacity=".16" stroke-width="3"><circle cx="250" cy="240" r="116"/><circle cx="250" cy="240" r="101"/><path d="M125 240h250M250 117v246"/></g>`;
    const font = value("font") === "sans" ? "Arial, sans-serif" : value("font") === "condensed" ? "Impact, sans-serif" : "Georgia, serif";
    const fontSize = Math.max(10, Math.min(24, Number(value("fontSize") || 16)));
    const top = xml(face.top || ""); const bottom = xml(face.bottom || ""); const number = xml(face.value);
    const textY = round ? { top: 134, mark: 205, number: 260, bottom: 351 } : { top: 155, mark: 210, number: 260, bottom: 346 };
    const motifY = round ? 225 : 246;
    const markStyle = `font-family="${font}" font-weight="700" fill="${textColor}" text-anchor="middle"`;
    const motif = (which, x) => state.images[side]?.[which] ? displayImage(side, which, x - 17, motifY - 17, 34) : `<text x="${x}" y="${motifY + 7}" text-anchor="middle" fill="${textColor}" font-size="28">${icon(face[which])}</text>`;
    return `<svg viewBox="0 0 500 480" role="img" aria-label="${xml(side)} poker chip preview"><defs>${clip}</defs>${base}${marks}${artwork}${round ? `<circle cx="250" cy="240" r="151" fill="none" stroke="${textColor}" stroke-opacity=".22" stroke-width="2"/>` : `<rect x="91" y="121" width="318" height="238" rx="25" fill="none" stroke="${textColor}" stroke-opacity=".24" stroke-width="2"/>`}${motif("left", 129)}${motif("right", 371)}<text x="250" y="${textY.top}" ${markStyle} font-size="${fontSize}" letter-spacing="2">${top}</text><text x="250" y="${textY.mark}" ${markStyle} font-size="${Math.round(fontSize * 1.1)}" letter-spacing="1">${xml(face.mark)}</text><text x="250" y="${textY.number}" text-anchor="middle" fill="${textColor}" font-family="${font}" font-weight="700" font-size="${round ? 76 : 68}">${number}</text><text x="250" y="${textY.bottom}" ${markStyle} font-size="${fontSize}" letter-spacing="2">${bottom}</text></svg>`;
  };
  const render = () => {
    preview.innerHTML = makePreview();
    const face = sideValues(state.previewSide);
    document.getElementById("chip-preview-stamp").textContent = `${state.previewSide.toUpperCase()} · ${face.value}`;
    document.getElementById("chip-preview-style").textContent = `${value("artStyle")} · ${checked("emboss") ? "Embossed" : "Smooth"}`;
    document.getElementById("chip-preview-shape").textContent = value("shape") === "rectangle" ? "Rectangle chip" : "Round chip";
    document.querySelector("[data-font-size-output]").textContent = value("fontSize");
  };
  const compressImage = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const image = new Image();
      image.onerror = reject;
      image.onload = () => {
        const scale = Math.min(1, 420 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale)); canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", .72));
      };
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
  const showUpload = (root, image, label) => {
    if (!root || !image) return;
    root.querySelector("img").src = image;
    root.querySelector("span").textContent = label;
    root.classList.add("is-visible");
  };
  form.querySelector("[data-artwork-input]").addEventListener("change", async event => {
    const file = event.target.files?.[0]; if (!file) return;
    try { state.images[state.editSide].artwork = await compressImage(file); field("artUploadMode").checked = true; field("artStyle").value = "custom"; showUpload(form.querySelector("[data-artwork-preview]"), state.images[state.editSide].artwork, `${file.name} · ${state.editSide}`); render(); }
    catch { document.getElementById("chip-save-status").textContent = "This image could not be loaded. Choose a PNG, JPG or WebP file."; }
  });
  form.querySelectorAll("[data-motif-input]").forEach(input => input.addEventListener("change", async event => {
    const file = event.target.files?.[0]; if (!file) return;
    try { const side = state.editSide; const which = input.dataset.motifInput; state.images[side][which] = await compressImage(file); render(); }
    catch { document.getElementById("chip-save-status").textContent = "This motif image could not be loaded."; }
  }));
  document.querySelectorAll("[data-edit-side]").forEach(button => button.addEventListener("click", () => {
    state.editSide = button.dataset.editSide;
    document.querySelectorAll("[data-edit-side]").forEach(item => item.setAttribute("aria-pressed", String(item === button)));
    document.querySelectorAll("[data-face-panel]").forEach(panel => panel.hidden = panel.dataset.facePanel !== state.editSide);
    const artToggle = field("artUploadMode"); artToggle.checked = Boolean(state.images[state.editSide].artwork);
    const previewWrap = form.querySelector("[data-artwork-preview]");
    if (state.images[state.editSide].artwork) showUpload(previewWrap, state.images[state.editSide].artwork, `Artwork · ${state.editSide}`); else previewWrap.classList.remove("is-visible");
    form.querySelector("[data-artwork-input]").value = "";
    render();
  }));
  document.querySelectorAll("[data-preview-side]").forEach(button => button.addEventListener("click", () => {
    state.previewSide = button.dataset.previewSide;
    document.querySelectorAll("[data-preview-side]").forEach(item => item.setAttribute("aria-pressed", String(item === button)));
    render();
  }));
  form.addEventListener("input", render);
  form.addEventListener("change", render);
  field("artStyle").addEventListener("change", () => { if (value("artStyle") !== "custom") field("artUploadMode").checked = false; render(); });

  const restoreDesign = design => {
    if (!design?.config) return;
    state.editingId = design.id;
    const savedFields = design.config.fields || {};
    Object.entries(savedFields).forEach(([name, saved]) => {
      const input = field(name); if (!input) return;
      if (input.type === "checkbox") input.checked = Boolean(saved);
      else if (input.type !== "file") input.value = saved;
    });
    state.images = design.config.images || { front: {}, back: {} };
    field("designName").value = design.name || "";
    const art = state.images[state.editSide]?.artwork;
    if (art) showUpload(form.querySelector("[data-artwork-preview]"), art, "Saved artwork");
    render();
  };
  const editId = new URLSearchParams(location.search).get("design");
  if (editId) restoreDesign(getDesigns().find(item => item.id === editId));
  render();

  form.addEventListener("submit", event => {
    if (event.submitter?.hasAttribute("data-shopify-add")) return;
    event.preventDefault();
    const name = value("designName").trim(); if (!name) return;
    const fields = {};
    [...form.elements].filter(item => item.name && item.type !== "file").forEach(item => { fields[item.name] = item.type === "checkbox" ? item.checked : item.value; });
    const designs = getDesigns();
    const existing = designs.find(item => item.id === state.editingId);
    const design = {
      ...(existing || {}), id: state.editingId || globalThis.crypto?.randomUUID?.() || `design-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      name, type: "chips", material: "Poker chips", notes: `${value("shape")} · ${value("artStyle")} · ${sideValues("front").value} chips`,
      config: { fields, images: state.images }, savedAt: new Date().toISOString()
    };
    const next = [design, ...designs.filter(item => item.id !== design.id)];
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      state.editingId = design.id;
      document.getElementById("chip-save-status").textContent = "Design saved in this browser. You can find it under My designs.";
    } catch {
      document.getElementById("chip-save-status").textContent = "There is not enough browser storage for this upload. Try a smaller image or remove an old design.";
    }
  });
})();
